export const specialCharactersRegex = /[.*+?^${}()|[\]\\]/gu;
export const numbersRegex = /[0-9,.]/u;
export const REOWN_URL = 'https://reown.com';
//# sourceMappingURL=ConstantsUtil.js.map